import React from "react";
import "../../snapshots/Tabs/tabs.css";

// This file renders the different tabs in the reports page
// The tabs include Text Report, Evidence Map and Tree Map
// Depending on the state, the number of snapshots will change

function ReportsTabs({ toggleState, toggleTab }) {
  const snapshotName = localStorage.getItem("selectedSnapshot");
  const isRepXFile = snapshotName.toLowerCase().includes("repx");
  return (
    <div className="bloc-tabs-topic">
      <div className="bloc">
        <div
          className={
            toggleState === "Text Report"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Text Report");
          }}
        >
          <p>Text Report</p>
        </div>
        <div
          className={
            toggleState === "Evidence Map"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Evidence Map");
          }}
        >
          <p>Evidence Map</p>
        </div>
        <div
          className={
            toggleState === "Treemap"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Treemap");
          }}
        >
          <p>Treemap</p>
        </div>
        {isRepXFile && (
          <div
            className={
              toggleState === "Files"
                ? "tabs-topic active-tabs-topic"
                : "tabs-topic"
            }
            onClick={() => {
              toggleTab("Files");
            }}
          >
            <p>RepX Files</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReportsTabs;
